'use client';

import { ReactNode } from 'react';

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface IAppSidebarSectionProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Creates a flyout menu wrapper for the sidebar, or aside elmeent.
 * TODO - Update this to be more robust and flexible.
 */
export function AppSidebarMobileFlyoutContainer({
  children,
  isOpen,
  onClose,
}: IAppSidebarSectionProps) {
  return (
    <Dialog className="relative z-50 lg:hidden" onClose={onClose} open={isOpen}>
      <DialogBackdrop
        className="
          fixed inset-0 bg-gray-900/80 transition-opacity duration-500 ease-linear
          data-[closed]:opacity-0
        "
        transition
      />

      <div className="fixed inset-0 flex">
        <DialogPanel
          className="
            relative me-16 flex w-full max-w-xs flex-1 transform transition duration-300
            ease-in-out data-[closed]:-translate-x-full
            rtl:data-[closed]:translate-x-full
          "
          transition
        >
          <TransitionChild>
            <div
              className="
                absolute start-full top-0 flex w-16 justify-center pt-5 duration-300
                ease-in-out data-[closed]:opacity-0
              "
            >
              <button className="-m-2.5 p-2.5" onClick={onClose} type="button">
                <span className="sr-only">Close sidebar</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6 text-white" />
              </button>
            </div>
          </TransitionChild>

          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
